type BankInfo = {
    bankName: string
    bankAddress: string
    leadingIbanAccountNumber: string
    swiftNumber: string | null
}

const bankData: BankInfo[] = [
    {
        bankName: 'Addiko bank d.d.',
        bankAddress: 'Slavonska avenija 6, 10000 Zagreb',
        leadingIbanAccountNumber: '2500009',
        swiftNumber: 'HAABHR22',
    },
    {
        bankName: 'Agram banka d.d.',
        bankAddress: 'Ulica grada Vukovara 74, 10000 Zagreb',
        leadingIbanAccountNumber: '2481000',
        swiftNumber: 'KREZHR2X',
    },
    {
        bankName: 'Aircash d.o.o.',
        bankAddress: 'Ulica grada Vukovara 271, 10000 Zagreb',
        leadingIbanAccountNumber: '4501006',
        swiftNumber: null,
    },
    {
        bankName: 'Banka kovanica d.d.',
        bankAddress: 'Petra Preradovića 29, 42000 Varaždin',
        leadingIbanAccountNumber: '4133006',
        swiftNumber: 'SKOVHR22 ',
    },
    {
        bankName: 'BKS Bank AG, Glavna podružnica Hrvatska',
        bankAddress: 'Mljekarski trg 3, 51000 Rijeka',
        leadingIbanAccountNumber: '2488001',
        swiftNumber: 'BFKKHR22',
    },
    {
        bankName: 'Croatia banka d.d.',
        bankAddress: 'Roberta Frangeša - Mihanovića 9, 10110 Zagreb',
        leadingIbanAccountNumber: '2485003',
        swiftNumber: 'CROAHR2X',
    },
    {
        bankName: 'Erste & Steiermärkische Bank d.d.',
        bankAddress: 'Jadranski trg 3A, 51000 Rijeka',
        leadingIbanAccountNumber: '2402006',
        swiftNumber: 'ESBCHR22',
    },
    {
        bankName: 'Hrvatska narodna banka',
        bankAddress: 'Trg hrvatskih velikana 3, 10000 Zagreb',
        leadingIbanAccountNumber: '1001005',
        swiftNumber: 'NBHRHR2X ',
    },
    {
        bankName: 'Hrvatska poštanska banka d.d.',
        bankAddress: 'Jurišićeva ulica 4, 10000 Zagreb',
        leadingIbanAccountNumber: '2390001',
        swiftNumber: 'HPBZHR2X',
    },
    {
        bankName: 'Imex Banka d.d.',
        bankAddress: 'Tolstojeva 6, 21000 Split',
        leadingIbanAccountNumber: '2492008',
        swiftNumber: 'IMXXHR22',
    },
    {
        bankName: 'Istarska kreditna banka Umag d.d.',
        bankAddress: 'Ernesta Miloša 1, 52470 Umag',
        leadingIbanAccountNumber: '2380006',
        swiftNumber: 'ISKBHR2X',
    },
    {
        bankName: 'J&T banka d.d.',
        bankAddress: 'Hallerova aleja 6E, 42000 Varaždin',
        leadingIbanAccountNumber: '2489004',
        swiftNumber: 'VBVZ HR 22',
    },
    {
        bankName: 'Karlovačka banka d.d.',
        bankAddress: 'Ivana Gorana Kovačića 1, 47000 Karlovac',
        leadingIbanAccountNumber: '2400008',
        swiftNumber: 'KALCHR2X',
    },
    {
        bankName: 'Kentbank d.d.',
        bankAddress: 'Gundulićeva ulica 1, 10 000 Zagreb',
        leadingIbanAccountNumber: '4124003',
        swiftNumber: 'KENBHR22',
    },
    {
        bankName: 'OTP banka d.d.',
        bankAddress: 'Domovinskog rata 61, 21000 Split',
        leadingIbanAccountNumber: '2407000',
        swiftNumber: 'OTPVHR2X',
    },
    {
        bankName: 'Partner banka d.d.',
        bankAddress: 'Vončinina 2, 10000 Zagreb',
        leadingIbanAccountNumber: '2408002',
        swiftNumber: 'PAZGHR2X',
    },
    {
        bankName: 'Podravska banka d.d.',
        bankAddress: 'Opatička 3, 48000 Koprivnica',
        leadingIbanAccountNumber: '2386002',
        swiftNumber: 'PDKCHR2X',
    },
    {
        bankName: 'Privredna banka Zagreb d.d.',
        bankAddress: 'Radnička cesta 50, 10000 Zagreb',
        leadingIbanAccountNumber: '2340009',
        swiftNumber: 'PBZGHR2X',
    },
    {
        bankName: 'Raiffeisenbank Austria d.d.',
        bankAddress: 'Magazinska cesta 69, 10000 Zagreb',
        leadingIbanAccountNumber: '2484008',
        swiftNumber: 'RZBHHR2X',
    },
    {
        bankName: 'Samoborska banka d.d.',
        bankAddress: 'Trg kralja Tomislava 8, 10430, Samobor',
        leadingIbanAccountNumber: '2403009',
        swiftNumber: 'SMBRHR22',
    },
    {
        bankName: 'Slatinska banka d.d.',
        bankAddress: 'Vladimira Nazora 2, 33 520 Slatina',
        leadingIbanAccountNumber: '2412009',
        swiftNumber: 'SBSLHR2X',
    },
    {
        bankName: 'Zagrebačka banka d.d.',
        bankAddress: 'Trg bana Josipa Jelačića 10, 10000 Zagreb',
        leadingIbanAccountNumber: '2360000',
        swiftNumber: 'ZABAHR2X',
    },
]

export function getBankInfo(bankAccountNumber: string): BankInfo | null {
    const leadingIdentifier = bankAccountNumber.substring(4, 11)
    return bankData.find(bank => bank.leadingIbanAccountNumber === leadingIdentifier) || null
}
